/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {useQueryResponseLoading, useQueryResponsePagination} from '../../core/QueryResponseProvider'
import {useQueryRequest} from '../../core/QueryRequestProvider'

const mappedLabel = (label: string) => {
  if (label === '&laquo; Anterior') {
    return '<< Anterior'
  }

  if (label === 'siguiente &raquo;') {
    return 'Siguiente >>'
  }

  return label
}

const LogsListPagination = () => {
  const pagination = useQueryResponsePagination()
  const isLoading = useQueryResponseLoading()
  const {updateState} = useQueryRequest()

  const {last_page, page, links} = pagination

  const updatePage = (desde: number) => {
    if (!desde || isLoading || pagination.desde === desde) {
      return
    }
    updateState({desde, item_per_page: pagination.item_per_page || 10})
  }

  const renderPaginationLinks = () => {
    if (last_page! <= 11) {
      return links?.map((link) => ({
        ...link,
        label: mappedLabel(link.label),
        url: link.url,
        page: link.page,
      }))
    }

    if (page! <= 6) {
      return [...links!.slice(0, 10), {label: '...', active: false}, ...links!.slice(-2)].map(
        (link) => {
          if ('url' in link && 'page' in link) {
            return {
              ...link,
              label: mappedLabel(link.label),
              url: link.url,
              page: link.page,
            }
          } else {
            return {
              ...link,
              label: mappedLabel(link.label),
            }
          }
        }
      )
    }

    if (page! >= last_page! - 5) {
      return [...links!.slice(0, 2), {label: '...', active: false}, ...links!.slice(-10)].map(
        (link) => {
          if ('url' in link && 'page' in link) {
            return {
              ...link,
              label: mappedLabel(link.label),
              url: link.url,
              page: link.page,
            }
          } else {
            return {
              ...link,
              label: mappedLabel(link.label),
            }
          }
        }
      )
    }

    return [
      ...links!.slice(0, 2),
      {label: '...', active: false},
      ...links!.slice(page! - 3, page! + 4),
      {label: '...', active: false},
      ...links!.slice(-2),
    ].map((link) => {
      if ('url' in link && 'page' in link) {
        return {
          ...link,
          label: mappedLabel(link.label),
          url: link.url,
          page: link.page,
        }
      } else {
        return {
          ...link,
          label: mappedLabel(link.label),
        }
      }
    })
  }

  return (
    <div className='row'>
      <div className='d-flex align-items-center justify-content-center justify-content-md-end'>
        <div id='kt_table_users_paginate'>
          <ul className='pagination'>
            {renderPaginationLinks()?.map((link) => (
              <li
                key={link.label}
                className={clsx('page-item', {
                  active: link.active,
                  disabled: isLoading || !('url' in link) || link.url === null || link.url === '',
                  previous: link.label === 'Anterior',
                  next: link.label === 'Siguiente',
                })}
              >
                <a
                  className={clsx('page-link', {
                    'page-text': link.label === 'Anterior' || link.label === 'Siguiente',
                    'me-5': link.label === 'Anterior',
                  })}
                  onClick={() =>
                    'page' in link && link.page !== null ? updatePage(link.page) : null
                  } // Verificar si 'page' está presente en 'link' y no es null
                  style={{cursor: 'pointer'}}
                >
                  {mappedLabel(link.label)}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export {LogsListPagination}
